import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=53c694b1&scoped=true&"
import script from "./AssetDetails.vue?vue&type=script&lang=js&"
export * from "./AssetDetails.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetails.vue?vue&type=style&index=0&id=53c694b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c694b1",
  null
  
)

export default component.exports